import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api, idempotencyKey, unwrap } from '@/api/client'
import type { Schemas } from '@/api/types'
import { orderKeys } from '@/features/orders/queries'

export const reportKeys = {
  list: (orderId: string) => ['reports', orderId] as const,
}

export function useReports(orderId: string) {
  return useQuery({
    queryKey: reportKeys.list(orderId),
    queryFn: () =>
      unwrap(api.GET('/api/v1/orders/{order_id}/reports', { params: { path: { order_id: orderId } } })),
  })
}

export function useCreateReport(orderId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: Schemas['ReportCreateRequest']) =>
      unwrap(
        api.POST('/api/v1/orders/{order_id}/reports', {
          body,
          params: { path: { order_id: orderId }, header: { 'Idempotency-Key': idempotencyKey() } },
        }),
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: reportKeys.list(orderId) })
      void qc.invalidateQueries({ queryKey: orderKeys.history(orderId) })
    },
  })
}

export function useDeleteReport(orderId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) =>
      unwrap(api.DELETE('/api/v1/reports/{id}', { params: { path: { id } } })),
    onSuccess: () => qc.invalidateQueries({ queryKey: reportKeys.list(orderId) }),
  })
}
